import { render, staticRenderFns } from "./resultList.vue?vue&type=template&id=10beea78&scoped=true"
import script from "./resultList.vue?vue&type=script&lang=js"
export * from "./resultList.vue?vue&type=script&lang=js"
import style0 from "./resultList.vue?vue&type=style&index=0&id=10beea78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10beea78",
  null
  
)

export default component.exports